// extracted by mini-css-extract-plugin
export default {"checkboxItem":"Checkbox_checkboxItem__HFbSz","checkboxItem_checkbox":"Checkbox_checkboxItem_checkbox__C8Txn","checkboxItem_label":"Checkbox_checkboxItem_label__7noEp"};